import * as yup from 'yup';

export const validationSchema = yup.object({
    branchName: yup
        .string()
        .required('Required'),
    branchCode: yup
        .string()
        .required('Required'),
    branchContact: yup
        .string()
        .required('Required'),
    branchEmail: yup
        .string()
        .required('Required'),
    type: yup
        .mixed()
        .oneOf(["branch", "branch_shipping", "shipping_address"])
        .required('Required'),
    address1: yup
        .string()
        .required('Required'),
    // address2: yup
    //     .string()
    //     .required('Required'),
    countryId: yup
        .string()
        .required('Required'),
    stateId: yup
        .string()
        .required('Required'),
    areaId: yup
        .string()
        .required('Required'),
    postcode: yup
        .string()
        .required('Required'),
    // picName: yup
    //     .string()
    //     .required('Required'),  
    // picContact: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    // picEmail: yup
    //     .string()
    //     .email('Enter a valid email')
    //     .required('Required'),
    isHQ: yup
        .bool()
        .required('Required'),
})

export const initialValues = {
    branchName: "",
    branchCode: "",
    branchContact: "",
    branchEmail: "",
    type: "",
    address1: "",
    address2: "",
    countryId:"",
    stateId: "",
    areaId:"",
    postcode:"",
    picName:"",
    picContact:"",
    picEmail:"",
    isHQ: false,
    status: true,
    branchRemark: "",
    userId: "",
    id: ""
}

export const retailTypes = [
    {
        id: "branch",
        display: "Outlet",
        default: false,
    },
    {
        id: "branch_shipping",
        display: "Outlet & Shipping Address",
        default: true,
    },
    {
        id: "shipping_address",
        display: "Shipping Address",
        default: false,
    }
]

export const branchDataTypes = [
    {
        id: "branch",
        display: "Branch",
        default: false,
    },
    {
        id: "branch_shipping",
        display: "Branch & Shipping Address",
        default: true,
    },
    {
        id: "shipping_address",
        display: "Shipping Address",
        default: false,
    }
]
